import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const DeathsOfWomenOfChildbearingAge = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Indice de Obitos de Mulheres em Idade Fertil'} 
            indicatorValue={chartData?.indicators?.deathsOfWomenOfChildbearingAge}
            className='aligned-container'
        />
    );
};
